module.exports = __webpack_public_path__ + "static/irene_3-beda5f182ee27256c61616629687e214.png";